import { ClickAwayListener } from '@mui/base';
import { Box } from '@mui/joy';
import { Funnel } from '@phosphor-icons/react';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'core/components';
import { Color, Size, Variant } from 'theme/enums';

import { FiltersPopover } from './FiltersPopover';

interface IProps {
  children: ReactNode;
  isActive: boolean;
  onReset: () => void;
}

export const FiltersButton = ({ children, isActive, onReset }: IProps) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  const { t } = useTranslation();

  const onTogglePanel = () => setIsPanelOpen((prev) => !prev);
  const onClosePanel = () => setIsPanelOpen(false);

  const onClickAway = () => {
    if (isPanelOpen) {
      onClosePanel();
    }
  };

  const onResetClick = () => {
    onReset();
    onClosePanel();
  };

  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <Box sx={{ position: 'relative' }}>
        <Button
          text={t('buttonLabelFilters')}
          startDecorator={<Funnel />}
          variant={isActive ? Variant.SOFT : Variant.OUTLINED}
          color={isActive ? Color.SUCCESS : Color.NEUTRAL}
          size={Size.SM}
          onClick={onTogglePanel}
        />

        {isPanelOpen && (
          <FiltersPopover showReset={isActive} onReset={onResetClick}>
            {children}
          </FiltersPopover>
        )}
      </Box>
    </ClickAwayListener>
  );
};
